import * as ResourceApi from 'api/resources';
import * as ServiceApi from 'api/services';

export const awardPoints = (uid, amount, reason) => ServiceApi.performAction(
  ResourceApi.Types.User,
  ServiceApi.Actions.AwardPoints,
  {
    uid,
    amount,
    reason
  }
);

export const awardSpins = (uid, amount) => ServiceApi.performAction(
  ResourceApi.Types.User,
  ServiceApi.Actions.AwardSpins,
  {
    uid,
    amount
  }
);

export const awardConsecutiveDays = (uid, amount) => ServiceApi.performAction(
  ResourceApi.Types.User,
  ServiceApi.Actions.AwardConsecutiveDays,
  {
    uid,
    amount
  }
);

export const changeEmail = (uid, newEmail) => ServiceApi.performAction(
  ResourceApi.Types.User,
  ServiceApi.Actions.ChangeEmail,
  {
    uid,
    newEmail,
  }
);

export const changePassword = (uid, newPassword, newPasswordConfirm) => ServiceApi.performAction(
  ResourceApi.Types.User,
  ServiceApi.Actions.ChangePassword,
  {
    uid,
    newPassword,
    newPasswordConfirm
  }
);

export const revokePoints = (uid, phid) => ServiceApi.performAction(
  ResourceApi.Types.User,
  ServiceApi.Actions.CancelTransaction,
  {
    uid,
    phid
  }
);

export const revokeAmountOfPoints = (uid, amount, reason) => ServiceApi.performAction(
  ResourceApi.Types.User,
  ServiceApi.Actions.RevokePoints,
  {
    uid,
    amount,
    reason
  }
);

export const repairProfile = uid => ServiceApi.performAction(
  ResourceApi.Types.User,
  ServiceApi.Actions.RepairProfile,
  {
    uid
  }
);

export const deactivateUser = uid => ServiceApi.performAction(
  ResourceApi.Types.User,
  ServiceApi.Actions.DeactivateUser,
  {
    uid
  }
);

export const deleteUserData = uid => ServiceApi.performAction(
  ResourceApi.Types.User,
  ServiceApi.Actions.DeleteUserData,
  {
    uid
  }
);



// WEBPACK FOOTER //
// ./public/api/user-management-service.js